import {gql} from "graphql-request";

// Fields the print queue needs to render a job's card and its progress.
const PRINT_MAP_QUEUE_FIELDS = `
  id
  title
  mapType
  status
  createdAt
  pdfUrl
  previewUrl
  pageCount
  renderedPageCount
  errorMessage
  pageSize
  orientation
  effectiveScaleDenominator
`;

export const CreatePrintMap = gql`
  mutation CreatePrintMap($printMap: CreatePrintMapInput!) {
    createPrintMap(input: $printMap) {
      ${PRINT_MAP_QUEUE_FIELDS}
    }
  }
`;

/**
 * Queue several sheets in one round trip. A sheet that fails validation is
 * reported in `errors` by its index; the rest still queue.
 */
export const CreatePrintMaps = gql`
  mutation CreatePrintMaps($printMaps: [PrintMapAttributesInput!]!) {
    createPrintMaps(input: { printMaps: $printMaps }) {
      printMaps {
        ${PRINT_MAP_QUEUE_FIELDS}
      }
      errors {
        index
        message
      }
    }
  }
`;

export const PrintMapQueue = gql`
  query PrintMapQueue($page: Int, $perPage: Int, $statuses: [String!]) {
    searchUserPrintMaps(page: $page, perPage: $perPage, statuses: $statuses) {
      printMaps {
        ${PRINT_MAP_QUEUE_FIELDS}
      }
      totalCount
      currentPage
      totalPages
      hasNextPage
    }
  }
`;

export const SearchUserPrintMaps = gql`
  query SearchUserPrintMaps(
    $query: String
    $page: Int
    $perPage: Int
    $mapType: String
    $statuses: [String!]
    $createdAtFrom: ISO8601Date
    $createdAtTo: ISO8601Date
  ) {
    searchUserPrintMaps(
      query: $query
      page: $page
      perPage: $perPage
      mapType: $mapType
      statuses: $statuses
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
    ) {
      printMaps {
        ${PRINT_MAP_QUEUE_FIELDS}
      }
      totalCount
      totalPages
      currentPage
      perPage
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const DeletePrintMap = gql`
  mutation DeletePrintMap($id: ID!) {
    deletePrintMap(input: { id: $id }) {
      id
    }
  }
`;
